// token key
export const TOKEN_KEY = 'TOKEN__';
export const SUB_TOKEN_KEY = 'SUB_TOKEN__';

export const TENANT_KEY = 'TENANT__';

export const LOCALE_KEY = 'LOCALE__';

// user info key
export const USER_INFO_KEY = 'USER__INFO__';

// project config key
export const PROJ_CFG_KEY = 'PROJ__CFG__KEY__';

export const PROJ_INFO_KEY = 'PROJ_INFO_KEY__';

export const MULTIPLE_TABS_KEY = 'MULTIPLE_TABS__KEY__';

// base global local key
export const APP_LOCAL_CACHE_KEY = 'COMMON__LOCAL__KEY__';

// base global session key
export const APP_SESSION_CACHE_KEY = 'COMMON__SESSION__KEY__';

// table 列设置
export const TABLE_SETTING_KEY = 'TABLE__SETTING__KEY__';

export const CacheTypeEnum = {
  SESSION: 0,
  LOCAL: 1,
};
export type CacheTypeEnum = (typeof CacheTypeEnum)[keyof typeof CacheTypeEnum];
